/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = {
  hotelAndTickets: 'hotelAndTickets',
  hotel: 'hotel',
  products: 'products'
}; export default Keys;